import { render, staticRenderFns } from "./AddExpertModel.vue?vue&type=template&id=4ea94a64&scoped=true"
import script from "./AddExpertModel.vue?vue&type=script&lang=js"
export * from "./AddExpertModel.vue?vue&type=script&lang=js"
import style0 from "./AddExpertModel.vue?vue&type=style&index=0&id=4ea94a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea94a64",
  null
  
)

export default component.exports